/* eslint-disable no-unused-vars */
/* eslint-disable no-unused-expressions */
import { all, put, takeLatest, takeEvery } from 'redux-saga/effects';
import firebase from 'firebase';
import { TYPES } from './findUsersActions';

export function* searchUsers({ searchText }) {
    const currentUserId = firebase.auth().currentUser.uid;
    const dbRef = firebase.database().ref('users');
    const snap = yield dbRef
        .orderByChild('searchableName')
        .startAt(`${searchText.toLowerCase()}%`)
        .endAt(searchText.toLowerCase() + '\uf8ff')
        .once('value');

    const val = yield snap.val();
    if (val && val[currentUserId]) {
        // remove current user from results
        delete val[currentUserId];
    }
    yield put({
        type: TYPES.SEARCH_USERS_RESULTS,
        results: val,
    });
}

export default function* saga() {
    yield all([takeEvery(TYPES.SEARCH_USERS, searchUsers)]);
}
